module.exports = __webpack_public_path__ + "img/20180111_190539-min.71c3ccc4.jpg";